import PropTypes from 'prop-types';

const Marker = ({ className = '', onClick, label, ...otherProps }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={`icon ${className}`} viewBox="0 0 35 42" onClick={onClick} {...otherProps}>
      <path
        d="M15.4995 38.0403C16.2801 38.6654 16.2802 38.6653 16.2803 38.6652L16.2806 38.6647L16.2819 38.6631L16.287 38.6568L16.3065 38.6324L16.3824 38.5372C16.4488 38.4538 16.5465 38.331 16.6718 38.1728C16.9224 37.8565 17.2835 37.3988 17.7265 36.8322C18.6122 35.6992 19.8259 34.1299 21.1376 32.3844C23.7478 28.9113 26.7913 24.682 28.3861 21.8152L28.3862 21.815C31.3374 16.5081 30.1315 9.66786 25.6775 5.21494L25.6774 5.21487C22.8669 2.40557 19.1822 1 15.4995 1C11.818 1 8.1321 2.40554 5.32162 5.21488L5.32148 5.21502C0.86858 9.66792 -0.337378 16.5082 2.61394 21.8151L2.614 21.8152C4.20882 24.682 7.25205 28.9113 9.8619 32.3844C11.1735 34.1298 12.3871 35.6992 13.2727 36.8321C13.7156 37.3987 14.0767 37.8564 14.3272 38.1728C14.4525 38.3309 14.5502 38.4538 14.6167 38.5372L14.6925 38.6323L14.7121 38.6568L14.7171 38.6631L14.7184 38.6647L14.7187 38.6651C14.7188 38.6652 14.7189 38.6653 15.4995 38.0403ZM15.4995 38.0403L16.2801 38.6654L15.4995 39.6403L14.7189 38.6653L15.4995 38.0403ZM15.4995 22.5287C11.5598 22.5287 8.3649 19.3336 8.3649 15.3952C8.3649 11.4522 11.5602 8.25738 15.4995 8.25738C19.44 8.25738 22.6352 11.4522 22.6352 15.3952C22.6352 19.3335 19.4403 22.5287 15.4995 22.5287Z"
        stroke="white"
        strokeWidth="2"
      />
      <rect x="6" y="6" width="19" height="19" rx="9.5" fill="white" />
      {label && (<text textAnchor="middle" x="15" y="21">{label}</text>)}
    </svg>
  );
}

Marker.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default Marker;